import { loadStripe } from "@stripe/stripe-js";
import { config } from "@/Common/envConfig";

export class StripeApiService {
  public loadStripe() {
    const apiDeviceTokenPassword = config.stripeKey;

    return loadStripe(apiDeviceTokenPassword);
  }
}
